export * from "./progress-ring.template";
